import classNames from 'classnames';
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren } from 'react';
import './style.scss';

type EllipsisTextProps = PropsWithChildren<DetailedHTMLProps<HTMLAttributes<HTMLSpanElement>, HTMLSpanElement>>;

const EllipsisText = ({ className, children, ...rest }: EllipsisTextProps) => (
  <span className={classNames('ellipsis-text', className)} {...rest}>
    {children}
  </span>
);

export default EllipsisText;
